"use client";
import classNames from "classnames";

import { useState } from "react";

export default function SizeSelector({ colour, className, onHoverColor = () => {}, onSelectColor = () => {} }) {
  const [selected, setSelected] = useState(colour[0]);
  const [cacheSelected, setCacheSelected] = useState(colour[0]);

  const handleClick = (e, item) => {
    e.stopPropagation();
    setSelected(item);
    setCacheSelected(item);
    if (typeof onSelectColor === "function") {
      onSelectColor(item);
    }
  };
  return (
    <div className={classNames(className)}>
      <div className="font-roboto">
        <label className="text-sm font-bold">Colour:</label>
        <label className="text-xs font-[500] ml-1">{selected && selected.name}</label>
      </div>
      <div className="flex gap-2">
        {colour.map((item, i) => (
          <div
            key={`product-color-${i}`}
            className={classNames("w-[30px] h-[30px] flex rounded-full cursor-pointer  border-2 hover:border-gold", {
              "border-gold ": selected && selected.hex === item.hex,
              "border-white ": !selected || selected.hex !== item.hex,
            })}
            onClick={e => handleClick(e, item)}
            onMouseEnter={() => {
              if (window.innerWidth > 1024) {
                setSelected(item);
                if (typeof onHoverColor === "function") {
                  onHoverColor(item);
                }
              }
            }}
            onMouseLeave={() => {
              if (window.innerWidth > 1024) {
                setSelected(cacheSelected);
                if (typeof onSelectColor === "function") {
                  onSelectColor(cacheSelected);
                }
              }
            }}
          >
            <div className="w-[22px] h-[22px] m-auto rounded-full " style={{ backgroundColor: item.hex }}></div>
          </div>
        ))}
      </div>
    </div>
  );
}
